import { render, staticRenderFns } from "./ServiceOrderTop5.vue?vue&type=template&id=5ebf6009&scoped=true&"
import script from "./ServiceOrderTop5.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderTop5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebf6009",
  null
  
)

export default component.exports